import React, { useEffect, useState } from "react";
//iconos
import instagram from "../assets/images/icons/redes-instagram.svg";
import youtube from "../assets/images/icons/redes-youtube.svg";
import pinterest from "../assets/images/icons/redes-pinterest.svg";
import facebook from "../assets/images/icons/redes-facebook.svg";
import tiktok from "../assets/images/icons/redes-tiktok.svg";
import linkedin from "../assets/images/icons/redes-linkedin.svg";
import { getSocialMedia } from "../services/getSocialMedia";

const RedesSociales = () => {
  const [redes, setRedes] = useState([]);

  useEffect(() => {
    getSocialMedia().then((res) => {
      const articulos = Object.values(res.data)[0];
      setRedes(articulos);
    });
  }, []);

  return redes.length ? (
    <>
      <ul id="socialMedia">
        
        {redes.map((social, index) => {

          let imgRedSocial
          /**
           * ATENCION!! ESCUCHEN TODOS LOS PUEBLOS DE LA TIERRA
           * ESTE SWITCH ES UNA SOLUCION **PROVISORIA**.. HASTA QUE SE PUEDA INCLUIR EN LA BASE DE DATOS CORRESPONDIENTE
           * LA RUTA A LOS LOGOS.
           * ES MENESTER UNA VEZ QUE SE REALICE ESTO ¡¡CAMBIAR!! ESTE SWITCH...
           * SALUDOS Y BENDICIONES QUERID@ LECTOR@.
           * 
           * ATTE.
           * 
           * LUCAS MADRIGAL
           */
          switch (social.name) {
            case "instagram":
              imgRedSocial = instagram
              break;
            case "facebook":
              imgRedSocial = facebook
              break;
            case "youtube":
              imgRedSocial = youtube
              break;
            case "linkedin":
              imgRedSocial = linkedin
              break;
            case "tiktok":
              imgRedSocial = tiktok
              break;
            case "pinterest":
              imgRedSocial = pinterest
              break;
          
            default:
              break;
          }
          if(social.link && !(social.deleted) && social.name !== "googleAnalytics"){
          return (<li key={index}>
            <a
              href={social.link}
              title={social.name}
              target="_blank"
              rel="noopener"
            >
              <img src={imgRedSocial} alt={`logo ${social.name}`} />
            </a>
          </li>)
          }else{
            return ""
          }
        })}
      </ul>
    </>
  ) : (
    ""
  );
};

export default RedesSociales;
